import { TableColumn } from "react-data-table-component";
import { IConfig, INotification } from "src/services/types";
import { Check } from 'feather-icons-react';
import './style.css';

export const columnsNotifications: (
    config: IConfig, 
    onShowUsers: (item: INotification) => void
) => TableColumn<INotification>[] = 
(config, onShowUsers) => {
      
    return (
[
    { 
      name: "N°",
      center: true,
      width: "70px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
      name: "TITLE",
      width: "200px",
      // center: true,
      cell: function OrderItems(item) {
        return (
          <div>
            { item?.title }
          </div>
        );
      },
    },
    {
      name: "BODY",
      // width: "200px",
      // center: true,
      cell: function OrderItems(item) {
        return (
          <div >
            { item?.body }
          </div>
        );
      },
    },
    {
      name: "CREATED AT",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <div className="text-center" >
            { item?.created_at }
          </div>
        );
      },
    },
    {
      name: "SUCCESS",
      width: "100px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <b className="text-center text-success" >
            { item?.sent_to_count - item?.failures_count }
          </b>
        );
      },
    },
    {
      name: "FAILED",
      width: "80px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <b className="text-center text-danger" >
            { item?.failures_count }
          </b>
        );
      },
    },
    {
      name: "",
      center: true,
      width: "125px",
      cell: function OrderItems(item) {
          return (
            <>
              <button
                  type="button"
                  className="btn btn-success btn-sm waves-effect waves-light"
                  onClick={(e) => (onShowUsers(item), e.currentTarget.blur())}
              >
                <span>View users</span>
                <Check size="16"/>
              </button>
            </>
          );
      },
    },
   
  ]
)}